module.exports = __webpack_public_path__ + "img/912RW.e6a7f6bf.jpg";